import { regions } from '../../lib/timezone';

export const countryOptions = [
  { label: 'United States', value: 'US' },
  { label: 'Canada', value: 'CA' },
];

export const timeZoneOptions = regions.map(region => ({ label: region.name, value: region.name }));
